import type { BxpWebOperationsDiagnostics } from './bxp-web-operations-client.types';

export type BxpWebOperationsErrorKind =
	| 'invalid-input'
	| 'network'
	| 'aborted'
	| 'http'
	| 'permission'
	| 'graphql'
	| 'payload'
	| 'malformed-response'
	| 'ambiguous-organization'
	| 'membership-pending';

export type BxpWebOperationsErrorOptions = {
	readonly operation: string;
	readonly kind: BxpWebOperationsErrorKind;
	readonly mutationOutcome: 'not-started' | 'failed' | 'unknown';
	readonly diagnostics?: BxpWebOperationsDiagnostics;
	readonly teamId?: string;
	readonly asyncRequestId?: string;
	readonly errorCodes?: readonly string[];
};

/** Sanitized, structured failure; known IDs survive partial or ambiguous responses. */
export class BxpWebOperationsError extends Error {
	public readonly operation: string;
	public readonly kind: BxpWebOperationsErrorKind;
	public readonly mutationOutcome: BxpWebOperationsErrorOptions['mutationOutcome'];
	public readonly diagnostics: BxpWebOperationsDiagnostics;
	public readonly teamId?: string;
	public readonly asyncRequestId?: string;
	public readonly errorCodes: readonly string[];

	public constructor(options: BxpWebOperationsErrorOptions) {
		super(`Operations ${options.operation} failed (${options.kind})`);
		this.name = 'BxpWebOperationsError';
		this.operation = options.operation;
		this.kind = options.kind;
		this.mutationOutcome = options.mutationOutcome;
		this.diagnostics = options.diagnostics ?? {};
		this.teamId = options.teamId;
		this.asyncRequestId = options.asyncRequestId;
		this.errorCodes = options.errorCodes ?? [];
	}
}
